import { createSlice } from '@reduxjs/toolkit'


/* v8 ignore start */
const initialState = {
    open: false,
    title: '',
    description: '',
    onConfirm: () => null,
    onHiding: () => null,
    confirm: '',
    cancel: '',
}
/* v8 ignore end */

export const showCPopup = (payload: any) => {
    return (dispatch: Function) => {
        const confirmCbWrapper = async () => {
            await payload.confirmCb()
            dispatch(closeCPopup())
        }

        const rejectCbWrapper = async () => {
            await (payload.rejectCb && payload.rejectCb())
            dispatch(closeCPopup())
        }

        dispatch(cPopupSlice.actions.showCPopup({ ...payload, onConfirm: confirmCbWrapper, onHiding: rejectCbWrapper }))
    }
}

const cPopupSlice = createSlice({
    name: 'cPopupSlice',
    initialState,
    reducers: {
        showCPopup: (state, action) => {
            return { ...state, ...action.payload, open: true }
        },
        closeCPopup: (_) => {
            return initialState
        }
    }
})

export const { closeCPopup, showCPopup: _showCPopup } = cPopupSlice.actions
export default cPopupSlice.reducer
